module.exports = __webpack_public_path__ + "img/horizontal_3_2_pp2_8017.ce4b6873.png";